
// import React, { useState } from "react";
// import { useNavigate, Link } from "react-router-dom";
// import API from "./axiosInstance";
// import "./Login.css";

// function Login() {
//   const [email, setEmail] = useState("");
//   const [password, setPassword] = useState("");
  
//   const navigate = useNavigate();

//   const handleLogin = async (e) => {
//     e.preventDefault();
//     try {
//       const res = await API.post("/auth/login", { email, password });

//       if (res.data.token) {
//         const userData = {
//           email: res.data.user.email || email,
//           name: res.data.user.name || "User",
//           role: res.data.user.role || "user",
//         };

//         localStorage.setItem("user", JSON.stringify(userData));

//         if (userData.role === "admin") {
//           localStorage.setItem("adminToken", res.data.token);
//           navigate("/admin");
//         } else {
//           localStorage.setItem("userToken", res.data.token);
//           navigate("/userdashboard");
//         }

//         alert("Login Successful ✅");
//       } else {
//         alert("Invalid credentials ❌");
//       }
//     } catch {
//       alert("Login failed. Please try again.");
//     }
//   };

//   return (
//     <div className="login-page">
//       <div className="login-card">
//         <h2>Welcome Back 👋</h2>
//         <p className="subtitle">Login to continue shopping</p>

//         <form onSubmit={handleLogin}>
//           <div className="input-group">
//             <input
//               type="email"
//               placeholder="Email Address"
//               value={email}
//               onChange={(e) => setEmail(e.target.value)}
//               required
//             />
//           </div>

//           <div className="input-group">
//             <input
//               type="password"
//               placeholder="Password"
//               value={password}
//               onChange={(e) => setPassword(e.target.value)}
//               required
//             />
//           </div>

//           <button type="submit" className="login-btn">
//             Login
//           </button>

//           <div className="links">
//             <Link to="/forgot-password">Forgot Password?</Link>
//           </div>

//           <p className="register-text">
//             Don’t have an account?
//             <Link to="/register"> Register</Link>
//           </p>
//         </form>
//       </div>
//     </div>
//   );
// }

// export default Login;
import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import API from "./axiosInstance";
import "./Login.css";

function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);

  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    try {
      const res = await API.post("/auth/login", { email, password });

      if (res.data.token) {
        const userData = {
          email: res.data.user.email || email,
          name: res.data.user.name || "User",
          role: res.data.user.role || "user",
        };

        localStorage.setItem("user", JSON.stringify(userData));

        if (userData.role === "admin") {
          localStorage.setItem("adminToken", res.data.token);
          navigate("/admin");
        } else {
          localStorage.setItem("userToken", res.data.token);
          navigate("/userdashboard");
        }

        alert("Login Successful ✅");
      } else {
        alert("Invalid credentials ❌");
      }
    } catch {
      alert("Login failed. Please try again.");
    }
  };

  return (
    <div className="login-page">
      <div className="login-card">
        <h2>Welcome Back 👋</h2>
        <p className="subtitle">Login to continue shopping</p>

        <form onSubmit={handleLogin}>
          <div className="input-group">
            <input
              type="email"
              placeholder="Email Address"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </div>

          <div className="input-group" style={{ position: "relative" }}>
            <input
              type={showPassword ? "text" : "password"}
              placeholder="Password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
            <span 
              onClick={() => setShowPassword(!showPassword)}
              style={{
                position: "absolute",
                right: "10px",
                top: "50%",
                transform: "translateY(-50%)",
                cursor: "pointer",
                fontSize: "18px"
              }}
            >
              {showPassword ? "🙈" : "👁"}
            </span>
          </div>

          <button type="submit" className="login-btn">
            Login
          </button>

          <div className="links">
            <Link to="/forgot-password">Forgot Password?</Link>
          </div>

          <p className="register-text">
            Don't have an account?
            <Link to="/register"> Register</Link>
          </p>
        </form>
      </div>
    </div>
  );
}

export default Login;